import { FUSE_CORE_DEFAULTS } from "../../utils/fuzzy-search/options";

const AGENCY_CODE_SEPARATOR = /[_/-]+/;

export const AGENCY_FUZZY_OPTIONS = {
	...FUSE_CORE_DEFAULTS,
	threshold: 0.3,
	ignoreLocation: true,
	ignoreFieldNorm: true,
	keys: [
		{
			name: "name",
			weight: 0.4
		},
		{
			name: "searchTerms",
			weight: 0.6,
			getFn: buildAgencySearchTerms
		}
	]
};

export function buildAgencySearchTerms(agency) {
	const code = cleanValue(agency?.code);
	const terms = [
		cleanValue(agency?.initials),
		code,
		...code.split(AGENCY_CODE_SEPARATOR),
		...(agency?.forms || []).flatMap((form) => [
			cleanValue(form?.name),
			cleanValue(form?.code)
		])
	];

	return [...new Set(terms.filter(Boolean))];
}

function cleanValue(value) {
	return typeof value === "string" ? value.trim() : "";
}
